import React from 'react';
import PropTypes from 'prop-types';

const DropdownContainer = ({ children, visible, style }) => {
  return (
    <div className="dropdown" hidden={!visible} style={style}>
      {children}
    </div>
  );
};

DropdownContainer.propTypes = {
  visible: PropTypes.bool.isRequired,
  children: PropTypes.node.isRequired,
  style: PropTypes.object,
};

export default DropdownContainer;
